import React from 'react';

import { appLinks } from '../../lib/constants/SiteVariables';
import AppStore from '../../lib/images/app-store.svg';
import GooglePlay from '../../lib/images/google-play.svg';

export default function MobileAppBadges() {
  return (
    <div className="flex flex-wrap items-start gap-4 sm:gap-6 sm:h-12">
      <a
        href={appLinks.appStore}
        target="_blank"
        rel="noopener noreferrer"
        className="w-auto sm:h-full h-10"
      >
        <img src={AppStore} alt="app store" className="h-full w-full" />
      </a>
      <a
        href={appLinks.googlePlay}
        target="_blank"
        rel="noopener noreferrer"
        className="w-auto sm:h-full h-10"
      >
        <img src={GooglePlay} alt="google play" className="h-full w-full" />
      </a>
    </div>
  );
}
